import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";
import { REACT_APP_CALL_SERVICE_URL } from "../constants/constants";

export const upsertNotes = async (payload) => {
  const endpoint = `${REACT_APP_CALL_SERVICE_URL}/upsert-notes`;

  const options = {
    method: "POST",
    body: payload,
  };

  return await fetchJSON(endpoint, options);
};

export const useUpsertNotes = () => {
  return useMutation({
    mutationFn: upsertNotes,
  });
};
